module.exports = __webpack_public_path__ + "static/media/case-1.0a4daade.png";